/**
 * Page-level background scene — three drifting color orbs over a cool
 * canvas gradient. Pair with GlassCard / GlassPill chrome to create the
 * refraction source. DESIGN.md §14 "Background layer."
 *
 * Render ONCE per authenticated app shell, behind everything else
 * (position: fixed, z-index: 0). Glass surfaces floating above it will
 * pick up the color via backdrop-filter saturate.
 */
export function GlassScene() {
  return (
    <div className="glass-scene" aria-hidden="true">
      <div className="glass-orb a" />
      <div className="glass-orb b" />
      <div className="glass-orb c" />
    </div>
  )
}
